import {
  IconPrinter,
  IconAutomation,
  IconBuildingWarehouse,
  IconCalendar,
  IconCalendarStar,
  IconCalendarWeek,
  IconClock2,
  IconContract,
  IconFileAnalytics,
  IconFolderOpen,
  IconHomeCog,
  IconHomeMove,
  IconId,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutGridAdd,
  IconListDetails,
  IconMasksTheater,
  IconMessageCircle,
  IconMusic,
  IconNews,
  IconQuestionMark,
  IconSettings,
  IconUsers,
  IconWorldCog,
  IconCalendarPause,
  IconLogs,
  IconUserCircle,
  IconMessages,
  IconClockQuestion,
  IconBell,
  IconBellRinging,
  IconReportMoney,
} from "@tabler/icons-react"
import { Text, RingProgress, ThemeIcon, ThemeIconProps } from "@mantine/core"
import { eNavigationTreeNodeId } from "../../../@client/Theasoft_Data"
import { IAttachmentUploadQueueItem } from "../../../attachment-api/components/attachment-upload-context"
import { AttachmentControllerRoute } from "../../../attachment-api"
import { match } from "ts-pattern"
import { IconContractCheck } from "../../../components/icons/IconContractCheck"
import { useHasOverdueReminderForCurrentUser } from "@/routes/app/my/reminders/-components/use-has-overdue-reminder"

interface IconSwitchProps {
  nodeId?: eNavigationTreeNodeId
  size?: number
  stroke?: number
}

const nodeIdToIcon = (nodeId: eNavigationTreeNodeId | undefined) =>
  match(nodeId)
    .with("Dashboard", () => IconLayoutGrid)
    .with("My", () => IconUserCircle)
    .with("WorkingTimes", () => IconClock2)
    .with("Abwesenheiten", () => IconHomeMove)
    .with("Communication", () => IconMessages)
    .with("Chat", () => IconMessageCircle)
    .with("Feeds", () => IconNews)
    .with("AbsenceApprovals", () => IconContract)
    .with("Orchester", () => IconMusic)
    .with("Pl\u00E4ne", () => IconFileAnalytics)
    .with("Produktionen", () => IconMasksTheater)
    .with("CalendarSubscriptions", () => IconCalendarStar)
    .with("DutyScheduling", () => IconCalendarWeek)
    .with("DutyScheduling_Absences", () => IconCalendarPause)
    .with("DutyScheduling_ShiftsAndCasts", () => IconCalendarWeek)
    .with("Dienstpl\u00E4ne", () => IconPrinter)
    .with("MeinRapport", () => IconId)
    .with("AdminEinstellungen", () => IconSettings)
    .with("DashboardKonfiguration", () => IconLayoutGridAdd)
    .with("AbwesenheitKonfiguration", () => IconHomeCog)
    .with("Benutzerverwaltung", () => IconUsers)
    .with("AdminInfo", () => IconInfoCircle)
    .with("MeinKalender", () => IconCalendar)
    .with("Kontakte", () => IconUsers)
    .with("Dispo", () => IconListDetails)
    .with("Files", () => IconFolderOpen)
    .with("Aufgabenplanung", () => IconAutomation)
    .with("GlobalSettings", () => IconWorldCog)
    .with("Resources", () => IconBuildingWarehouse)
    .with("Logging", () => IconLogs)
    .with("ContractsGroup", () => IconContract)
    .with("Contracts", () => IconContract)
    .with("ContractApprovals", () => IconContractCheck)
    .with("Art", () => IconMasksTheater)
    .with("Webkalender", () => IconContract)
    .with("WorkingTimeBooking", () => IconClockQuestion)
    .with("Reminders", () =>
      useHasOverdueReminderForCurrentUser().data ? IconBellRinging : IconBell
    )
    .with("Tantiemen", () => IconReportMoney)
    .with(undefined, () => IconQuestionMark)
    .exhaustive()

function IconSwitch({ nodeId, ...props }: IconSwitchProps) {
  const Icon = nodeIdToIcon(nodeId)
  return <Icon {...props} />
}

interface Props extends Omit<ThemeIconProps, "size">, IconSwitchProps {
  uploadQueue?: IAttachmentUploadQueueItem<AttachmentControllerRoute>[]
}

export function RouteIcon({
  nodeId,
  size,
  stroke,
  uploadQueue,
  ...props
}: Props) {
  return (
    <ThemeIcon variant="transparent" size={size} color="blue" {...props}>
      {nodeId === "Files" && uploadQueue?.length ? (
        <RingProgress
          size={44}
          thickness={4}
          sections={[{ value: 40, color: "blue" }]}
          label={
            <Text c="blue" ta="center" size="xs">
              40%
            </Text>
          }
        />
      ) : (
        <IconSwitch nodeId={nodeId} size={size} stroke={stroke} />
      )}
    </ThemeIcon>
  )
}
